import GeneralConstants from './general'

const Constants = {
  general: GeneralConstants,
}

export default Constants
